// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
import unity from '@/views/unity';
import home from '@/views/home';
import schoollits from '@/views/admin/school/schoollits.vue';
import shiyanguanli from '@/views/admin/school/shiyanguanli.vue';
import classlist from '@/views/class/classllits.vue';
import xiaoguanclassllits from '@/views/class/xiaoguanclassllits.vue';
import user from '@/views/useradmin/user.vue';
import xiaoguanuser from '@/views/useradmin/xiaoguanuser.vue';
import xiaoguanteacherUser from '@/views/useradmin/xiaoguanteacherUser.vue';
import myinfo from '@/views/my/myinfo.vue';
import shiyanteacher from '@/views/shiyan/shiyanteacher.vue';
import shiyan from '@/views/shiyan/shiyan.vue';
// 启用路由
Vue.use(Router);

// 导出路由 
export default new Router({
    routes: [


        {
            path: '/',
            name: '',
            component: login,
            hidden: true,
            meta: {
                requireAuth: false
            }
        },
         // 首页
        {
            path: '/home',
            name: 'home',
            component: home,
            hidden: true,
            meta: {
                requireAuth: false
            }
        },
        // unity
        {
            path: '/unity',
            name: 'unity',
            component: unity,
            meta: {
                requireAuth: false
            }
        },

        {
            path: '/index',
            name: '首页',
            component: index,
            iconCls: 'el-icon-tickets',
            children: [
                {
                    path: '/school/shiyanguanli',
                    name: '实验配置',
                    component: shiyanguanli,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/school/schoollits',
                    name: '学校详情',
                    component: schoollits,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/class',
                    name: '班级详情',
                    component: classlist,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/xiaoguanclassllits',
                    name: '班级详情',
                    component: xiaoguanclassllits,
                    meta: {
                        requireAuth: true
                    }
                },

                {
                    path: '/user',
                    name: '账号详情',
                    component: user,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/xiaoguanuser',
                    name: '班级账号',
                    component: xiaoguanuser,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/xiaoguanteacherUser',
                    name: '老师账号',
                    component: xiaoguanteacherUser,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/my/infos',
                    name: '个人详情',
                    component: myinfo,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/shiyan/shiyan',
                    name: '实验详情',
                    component: shiyan,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/shiyan/shiyanteacher',
                    name: '班级实验详情',
                    component: shiyanteacher,
                    meta: {
                        requireAuth: true
                    }
                },
            ]
        }]
})


// WEBPACK FOOTER //
// ./src/router/index.js